import React, { useCallback, useState } from 'react'
import { GetCard } from '@web/walter-lib/api'

import cn from 'classnames'
import Question from './views/Question/Question'
import Success from './views/Success/Success'
import s from './s.module.css'
import { usePromise } from '~hooks/usePromise'
import { cardsApi, useCards } from '~api'
import { processPermissionError } from '~utils/processPermissionError'
import Confirmation from '~components/ConfirmationModal/Confirmation'

interface Props {
    onClose: () => void
    card?: GetCard
}

function Content({ onClose, card }: Props) {
    const [view, setView] = useState('question')
    const [confirmModal, setConfirmModal] = useState({ showTwoFa: false, showVerificationCode: false })
    const { mutate: mutateCards } = useCards()

    const { send: onFreeze, isLoading } = usePromise(async () => {
        try {
            await cardsApi.freezeCards({
                id: card?.id || '',
            })

            await mutateCards()

            setView('success')
        } catch (error) {
            const { showVerificationCode, showTwoFa } = processPermissionError(error)

            if (showVerificationCode || showTwoFa) {
                setConfirmModal({ showTwoFa, showVerificationCode })
                setView('confirm')
                return
            }

            throw error
        }
    })

    const onSuccessConfirm = useCallback(() => {
        setView('question')
        void onFreeze()
    }, [onFreeze, setView])

    return (
        <>
            <div className={cn(view !== 'question' && s.hide)}>
                <Question onClose={onClose} onFreeze={onFreeze} isLoading={isLoading} />
            </div>
            {view === 'confirm' && (
                <Confirmation
                    initialInputState="pending"
                    onSuccess={onSuccessConfirm}
                    showTwoFa={confirmModal?.showTwoFa || false}
                    showVerificationCode={confirmModal?.showVerificationCode || false}
                    resource={cardsApi.resources.freeze(card?.id || '')}
                />
            )}
            {view === 'success' && <Success onClose={onClose} />}
        </>
    )
}

export default Content
